var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayIconVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "35px",
    viewBox: "0 0 50 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "control/base/app-icon-placeholer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI---Settings",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "App-portal/settings/Billing",
    transform: "translate(-565.000000, -1536.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-2",
    transform: "translate(535.000000, 1360.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1.000000, 173.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Visa-",
    transform: "translate(29.000000, 2.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.0034676,0.5 C47.6919588,0.5 48.3151694,0.78090786 48.7667034,1.23284535 C49.2195061,1.68605281 49.5,2.31141992 49.5,2.99921059 L49.5,32.0007894 C49.5,32.6914398 49.2211881,33.3167704 48.7691714,33.7691911 C48.3179113,34.2208546 47.6941083,34.5 47.0034676,34.5 L2.99653242,34.5 C2.30804117,34.5 1.68483057,34.2190921 1.23329664,33.7671546 C0.780493876,33.3139472 0.5,32.6885801 0.5,32.0007894 L0.5,2.99921059 C0.5,2.3085602 0.778811871,1.68322961 1.23082856,1.23080892 C1.68208875,0.779145424 2.30589174,0.5 2.99653242,0.5 Z",
    id: "Rectangle-Copy-4",
    stroke: "#E6E7E8",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Visa_Inc._logo",
    transform: "translate(8.333333, 12.173913)",
    fill: "#0742A6"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "polygon9",
    points: "14.4108666 10.4573851 11.7292799 10.4573851 13.4065364 0.313384291 16.0879765 0.313384291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1318568,0.561376166 C23.6029301,0.356126674 22.7640086,0.12950599 21.7266846,0.12950599 C19.0785315,0.12950599 17.2137238,1.51074472 17.202286,3.48550014 C17.1802901,4.94247034 18.5374337,5.75170698 19.5524686,6.23750715 C20.5899393,6.73392119 20.942606,7.0579314 20.942606,7.50041545 C20.932048,8.17999064 20.1042711,8.49324354 19.3322169,8.49324354 C18.2616058,8.49324354 17.6879542,8.33174044 16.8161856,7.95365682 L16.4630789,7.79158 L16.0878298,10.0686876 C16.7167643,10.3489514 17.8755054,10.5976604 19.0785315,10.6085612 C21.8922399,10.6085612 23.7240539,9.24869363 23.7457564,7.14427674 C23.7564611,5.98951527 23.0398365,5.10469059 21.4948483,4.38165586 C20.5569455,3.91751375 19.9825607,3.60454772 19.9825607,3.1296483 C19.9935586,2.69792155 20.4683756,2.25572436 21.5271089,2.25572436 C22.3988776,2.2340663 23.0393966,2.43902894 23.5246249,2.644135 L23.7671657,2.75185154 L24.1318568,0.561376166 L24.1318568,0.561376166 L24.1318568,0.561376166 Z",
    id: "path11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6959169,6.86372608 C27.9167551,6.28096668 28.7665279,4.02551715 28.7665279,4.02551715 C28.7553834,4.04717521 28.9869263,3.43200045 29.1193413,3.05434712 L29.3067459,3.92841449 C29.3067459,3.92841449 29.8145566,6.35655472 29.9248291,6.86372608 C29.5057349,6.86372608 28.2255768,6.86372608 27.6959169,6.86372608 L27.6959169,6.86372608 Z M31.0059982,0.313384291 L28.93179,0.313384291 C28.2921509,0.313384291 27.8061894,0.49668887 27.5302148,1.1550363 L23.5470606,10.4572417 L26.3607691,10.4572417 C26.3607691,10.4572417 26.8240016,9.20523409 26.9235694,8.93558416 C27.2322445,8.93558416 29.9694074,8.93558416 30.3665057,8.93558416 C30.4434911,9.29172287 30.6864719,10.4572417 30.6864719,10.4572417 L33.1693628,10.4572417 L31.0059982,0.313384291 L31.0059982,0.313384291 L31.0059982,0.313384291 Z",
    id: "path13",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48951637,0.313384291 L6.86335917,7.23062209 L6.57638672,5.82772532 C6.09086511,4.20896516 4.56816611,2.45021654 2.86891379,1.57571887 L5.27437936,10.4466278 L8.11008364,10.4466278 L12.325074,0.313384291 L9.48951637,0.313384291 L9.48951637,0.313384291 L9.48951637,0.313384291 Z",
    id: "path15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4247532,0.313384291 L0.110341602,0.313384291 L0.0662032744,0.518346923 C3.43171414,1.36014236 5.66062639,3.38925807 6.57638672,5.82815561 L5.6384839,1.16608047 C5.48407307,0.518203492 5.00954939,0.334755482 4.4247532,0.313384291 L4.4247532,0.313384291 Z",
    id: "path17"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayIconVisa);
export default __webpack_public_path__ + "static/media/pay-icon-visa.74ccd608ab4ac69a948520186dbdfb87.svg";
export { ForwardRef as ReactComponent };